import React from 'react';
interface BrandChipsProps {
  brands: string[];
  className?: string;
}
export function BrandChips({
  brands,
  className = ''
}: BrandChipsProps) {
  return <div className={`flex flex-wrap gap-2 ${className}`} data-id="element-13">
      {brands.map((brand, index) => <span key={index} className="px-3 py-1 text-sm font-medium text-white/80 bg-white/10 rounded-full border border-white/20" data-id="element-14">
          {brand}
        </span>)}
    </div>;
}